import {
  CREATE_GOLF_COURSE_SLOT,
  CREATE_GOLF_COURSE_SLOT_SUCCESS,
  CREATE_GOLF_COURSE_SLOT_ERROR,
  CREATE_GOLF_COURSE_SLOT_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const createGolfCourseSlot = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_GOLF_COURSE_SLOT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_GOLF_COURSE_SLOT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_GOLF_COURSE_SLOT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_GOLF_COURSE_SLOT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default createGolfCourseSlot;
